export const PAGE_SIZES = [1, 5, 10, 25, 50, 100]

const tables = {
    sites: {
        visibleKeys: ['name', 'location', 'dayOfMonth', 'created'],
        keyTypes: {
            apiKey: 'text',
            location: 'text',
            _id: 'text',
            created: 'datetime',
            dayOfMonth: 'text',
        },
        sortTableKeys: ['created'],
    },
    users: {
        visibleKeys: ['firstName', 'lastName', 'email', 'phone', 'role', 'status'],
        keyTypes: {
            firstName: 'text',
            lastName: 'text',
            email: 'email',
            phone: 'text',
            role: 'text',
            status: 'text',
        },
        sortTableKeys: ['status'],
        keyTranslate: {
            role: 'selectOptions',
            status: 'selectOptions',
        },
    },
    invites: {
        visibleKeys: ['email', {key: 'account', value: 'name'}, 'role', 'expireTime'],
        keyTypes: {
            email: 'email',
            account: 'text',
            role: 'text',
            expireTime: 'tokenTimeLeft',
        },
        sortTableKeys: ['expireTime'],
        keyTranslate: {
            role: 'selectOptions',
        },
    },
    meters: {
        visibleKeys: [
            'name',
            {key: 'account', value: 'name'},
            'meterId',
            {key: 'structure', value: 'name'},
            {key: 'consumer', value: 'name'},
            'category',
            {key: 'meterReading', value: 'date'},
            'conversionRate',
            'rolloverValue',
            'active',
        ],
        keyTypes: {
            name: 'text',
            account: 'text',
            meter: 'text',
            structure: 'text',
            category: 'text',
            consumer: 'text',
            meterReading: 'datetime',
            conversionRate: 'text',
            rolloverValue: 'text',
            active: 'boolean',
        },
        sortTableKeys: ['account', 'structure', 'type'],
    },
    consumers: {
        visibleKeys: [
            'name',
            {key: 'account', value: 'name'},
            {key: 'structure', value: 'name'},
            'email',
            'phone',
            'charging_date',
            'taoz',
            'last_invoice_date',
            'status',
        ],
        keyTypes: {
            name: 'text',
            email: 'text',
            phone: 'number',
            account: 'text',
            structure: 'text',
            charging_date: 'text',
            taoz: 'boolean',
            last_invoice_date: 'datetime',
            status: 'text',
        },
        keyTranslate: {
            charging_date: 'selectOptions',
            status: 'selectOptions',
        },
    },
    structures: {
        visibleKeys: ['name', {key: 'account', value: 'name'}, 'location'],
        keyTypes: {
            name: 'text',
            account: 'text',
            location: 'text',
        },
    },
    rates: {
        visibleKeys: [
            'name',
            {key: 'account', value: 'name'},
            'category',
            'hours',
            'months',
            'rate',
            'typeDay',
            'status',
        ],
        keyTypes: {
            account: 'text',
            name: 'RateName',
            category: 'text',
            rate: 'price',
            hours: 'rangeHours',
            months: 'range',
            typeDay: 'text',
            status: 'boolean',
        },
        keyTranslate: {
            typeDay: 'selectOptions',
            category: 'selectOptions',
        },
        externalKey: {
            name: ['isLive'],
        },
    },
    meter_readings: {
        visibleKeys: [
            {key: 'account', value: 'name'},
            {key: 'meter', value: 'name'},
            'date',
            'value',
            'absolute_value',
            'price',
            'status',
        ],
        keyTypes: {
            account: 'text',
            meter: 'text',
            date: 'datetime',
            value: 'ValueWithOriginal',
            absolute_value: 'numberFixed',
            price: 'priceFixed',
            status: 'StatusMeterReading',
        },
        sortTableKeys: ['date', 'value', 'absolute_value', 'price'],
        sortTableKeysDefaultDesc: ['date'],
        externalKey: {
            value: ['original_value'],
            status: ['invoice_number', 'failure_details', 'is_new_meter'],
        },
        // keyTranslate: {
        //     status: 'selectOptions',
        // },
    },
    invoices: {
        visibleKeys: [
            {key: 'account', value: 'name'},
            {key: 'consumer', value: 'name'},
            'created',
            'from_date',
            'to_date',
            'creation_method',
            'number',
            'total_price',
            'is_paid',
        ],
        keyTypes: {
            account: 'text',
            meter: 'text',
            consumer: 'text',
            from_date: 'datetime',
            to_date: 'datetime',
            total_price: 'numberFixed',
            created: 'datetime',
            creation_method: 'text',
            number: 'invoiceNumber',
            is_paid: 'UpdateIsPaid',
        },
        keyTranslate: {
            creation_method: 'selectOptions',
        },
        externalKey: {
            is_paid: ['_id', 'status'],
        },
        sortTableKeys: ['created', 'from_date', 'to_date', 'consumer'],
        sortTableKeysDefaultDesc: ['from_date'],
    },
    audit_logs: {
        visibleKeys: ['created', {key: 'account', value: 'name'}, 'action', 'entity', 'actor'],
        keyTypes: {
            created: 'datetime',
            account: 'text',
            action: 'auditAction',
            entity: 'auditEntity',
            actor: 'auditActor',
        },
        externalKey: {
            entity: ['meta'],
            changes: ['meta'],
        },
        sortTableKeys: ['created'],
        sortTableKeysDefaultDesc: ['created'],
    },
    fault_logs: {
        visibleKeys: [
            {key: 'account', value: 'name'},
            {key: 'meter', value: 'name'},
            {key: 'structure', value: 'name'},
            'created',
            'error',
            'message',
        ],
        keyTypes: {
            meter: 'text',
            error: 'text',
            account: 'text',
            structure: 'name',
            created: 'datetime',
            message: 'tooltip',
        },
        sortTableKeys: ['created'],
        keyTranslate: {
            error: 'selectOptions',
        },
    },
    payments: {
        visibleKeys: [
            {key: 'account', value: 'name'},
            'amount',
            'currency',
            {key: 'invoice', value: 'number'},
            'status',
            'tokenExpiresAt',
            'created',
        ],
        keyTypes: {
            account: 'text',
            amount: 'priceFixed',
            currency: 'text',
            status: 'PaymentStatus',
            created: 'datetime',
            invoice: 'invoiceNumber',
            tokenExpiresAt: 'tokenTimeLeft',
        },
        sortTableKeys: ['created', 'amount', 'status', 'invoice', 'tokenExpiresAt'],
        sortTableKeysDefaultDesc: ['created'],
        keyTranslate: {
            status: 'selectOptions',
        },
    },
    queue_jobs: {
        visibleKeys: [
            'id',
            'name',
            'state',
            'progress',
            'attemptsMade',
            'processedOn',
            'finishedOn',
            'failedReason',
        ],
        keyTypes: {
            id: 'text',
            name: 'text',
            state: 'text',
            progress: 'number',
            attemptsMade: 'number',
            processedOn: 'datetime',
            finishedOn: 'datetime',
            failedReason: 'text',
        },
        keyTranslate: {
            state: 'selectOptions',
        },
        sortTableKeys: ['processedOn', 'finishedOn', 'state'],
    },
    email_broadcasts: {
        visibleKeys: [
            'subject',
            'recipientType',
            'scope',
            'recipientCount',
            {key: 'sentBy', value: 'name'},
            'status',
            'created',
        ],
        keyTypes: {
            subject: 'text',
            recipientType: 'text',
            scope: 'text',
            recipientCount: 'number',
            sentBy: 'text',
            status: 'text',
            created: 'datetime',
        },
        keyTranslate: {
            recipientType: 'email_broadcast_recipient_type_options',
            scope: 'email_broadcast_scope_options',
            status: 'email_broadcast_status_options',
        },
        sortTableKeys: ['created'],
        sortTableKeysDefaultDesc: ['created'],
    },
}

export default tables
